import { combineReducers } from '@reduxjs/toolkit';

import estimate from './estimate/reducers';
import { api } from './api';

export default combineReducers({
  [api.reducerPath]: api.reducer,
  estimate,
});
